import { render, staticRenderFns } from "./shank.vue?vue&type=template&id=38305d02&"
import script from "./shank.vue?vue&type=script&lang=js&"
export * from "./shank.vue?vue&type=script&lang=js&"
import style0 from "./shank.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38305d02')) {
      api.createRecord('38305d02', component.options)
    } else {
      api.reload('38305d02', component.options)
    }
    module.hot.accept("./shank.vue?vue&type=template&id=38305d02&", function () {
      api.rerender('38305d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ota/firmware/shank.vue"
export default component.exports